import { render } from "./SortField.vue?vue&type=template&id=5c29593b"
import script from "./SortField.vue?vue&type=script&lang=js"
export * from "./SortField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__